// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const desertArch = defineModel({
  id: "desert-arch",
  batchId: "future",
  name: "Desert arch",
  tags: ["scenery","desert","arch","low-poly","age-of-mcp","future"],
  summary: "A wind-carved sandstone arch — a desert landmark.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.55,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.1, 0.17, 0.6, 6), color: "#bf6a3c", position: [-0.46, 0.3, 0], rotation: [0, 0, 0.1], scale: [1, 1, 0.7] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.17, 0.6, 6), color: "#a4552e", position: [0.46, 0.3, 0], rotation: [0, 0, -0.1], scale: [1, 1, 0.7] },
      { geometry: new THREE.BoxGeometry(0.16, 0.05, 0.18), color: "#9a4d2a", position: [-0.46, 0.24, 0], rotation: [0, 0, -0.1] },
      { geometry: new THREE.BoxGeometry(0.15, 0.04, 0.17), color: "#d4824f", position: [-0.46, 0.42, 0], rotation: [0, 0, -0.1] },
      { geometry: new THREE.BoxGeometry(0.16, 0.05, 0.18), color: "#9a4d2a", position: [0.46, 0.24, 0], rotation: [0, 0, 0.1] },
      { geometry: new THREE.BoxGeometry(0.15, 0.04, 0.17), color: "#d4824f", position: [0.46, 0.42, 0], rotation: [0, 0, 0.1] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#d4824f", position: [-0.394286, 0.658367, 0], rotation: [0, 0, 0.686743] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#bf6a3c", position: [-0.262857, 0.748163, 0], rotation: [0, 0, 0.500217] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#a4552e", position: [-0.131429, 0.802041, 0], rotation: [0, 0, 0.266778] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#d4824f", position: [0, 0.82, 0] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#bf6a3c", position: [0.131429, 0.802041, 0], rotation: [0, 0, -0.266778] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#a4552e", position: [0.262857, 0.748163, 0], rotation: [0, 0, -0.500217] },
      { geometry: new THREE.BoxGeometry(0.171429, 0.18, 0.22), color: "#d4824f", position: [0.394286, 0.658367, 0], rotation: [0, 0, -0.686743] },
      { geometry: new THREE.BoxGeometry(0.69, 0.04, 0.1), color: "#9a4d2a", position: [0, 0.74, 0.07] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#a4552e", position: [-0.54, 0.05, 0.12], rotation: [0.3, 0.5, 0.2], scale: [1.1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#bf6a3c", position: [0.56, 0.04, -0.1], rotation: [0.2, 1, 0.3], scale: [1.1, 0.7, 1] },
    ],
  animations: [],
});
